module.exports = __webpack_public_path__ + "assets/img/sabc_close_burgermenu.svg?888573173f79e25031a13a52d6acdb41";